import Config from "services/config/config";
import callWebService, {
    callTypes
} from "services/utils/networks/network";
import { CREATE_INCENTIVE_SLAB } from "./type";

export const createIncentiveSlab = (requestParams) => async (dispatch) => {

    try {
        const res = await callWebService(
            callTypes.post,
            {
                'gmc': requestParams.gmc,
                'rating': requestParams.rating,
                'drop_tat': requestParams.drop_tat,
                'online_txn': requestParams.online_txn,
                'project_id': requestParams.project_id,
            },
            `${Config.valet.incentiveSlab}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: CREATE_INCENTIVE_SLAB,
                payload: data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: CREATE_INCENTIVE_SLAB,
            payload: null,
        });
        return true;
    }
}